import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Card({ children, className = "", dark, flush, ...rest }) {
    const surface = dark
        ? "bg-[var(--text-primary)] text-white"
        : "bg-[var(--card-bg)] border border-[var(--card-border)] shadow-card";
    return (_jsx("div", { className: `rounded-2xl overflow-hidden ${surface} ${className}`, ...rest, children: flush ? children : _jsx("div", { className: "p-5", children: children }) }));
}
export function CardHeader({ title, action, className = "", }) {
    return (_jsxs("div", { className: `flex items-center justify-between border-b border-[var(--divider)] px-5 py-4 ${className}`, children: [_jsx("h2", { className: "text-sm font-bold text-[var(--text-primary)]", children: title }), action ? (_jsx("span", { className: "cursor-pointer text-xs font-medium text-[var(--text-secondary)] transition-colors hover:text-[var(--text-primary)]", children: action })) : null] }));
}
export function CardBody({ children, className = "", }) {
    return _jsx("div", { className: `px-5 py-5 ${className}`, children: children });
}
//# sourceMappingURL=Card.js.map